module.exports = __webpack_public_path__ + "img/logo-AM.ee58b10a.svg";